import type { FunctionComponent } from 'react';

export const SoftSkillIcon: FunctionComponent = ({ ...props }) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="12" style={{ flexShrink: 0 }} viewBox="0 0 16 16" width="12" {...props}>
            <circle cx="8" cy="8" fill="currentColor" r="7" />
        </svg>
    );
};
